function applyCTAStyles() {
    const links = document.querySelectorAll(".cta-box a");
    links.forEach(link => {
      link.style.setProperty("margin", "auto");
      link.style.setProperty("display", "flex");
      link.style.setProperty("justify-content", "center");
    });
  }

document.addEventListener("DOMContentLoaded", applyCTAStyles);

function applyArticleStyles() {
    const boldElements = document.querySelectorAll(".article__content h2 b, .article__content h3 b, .article__content h4 b, .article__content h5 b, .article__content h6 b");
    boldElements.forEach(element => {
        element.style.setProperty("font-weight", "400");
    });
}  

document.addEventListener("DOMContentLoaded", applyArticleStyles);

// Select Hyperlinks
function boldUnderlineAndLinkWords() {
    const debugLinkWords = false;
    const debugTerms = ['CRY+', 'CRY+™', 'CRY-M', 'CRY'];
    const minimumCharactersBetweenSameLinks = 4500;
    const wordLinks = {
        'CRX': '/products/crx-filter-media',
        'CRX-M': '/products/medium-flow-crx',
        'CRX Medium Flow': '/products/medium-flow-crx',
        'CRY': '/products/cry-filter-media',
        'CRY-M': '/products/cry-medium-flow',
        'CRY Medium Flow': '/products/cry-medium-flow',
        'CR41': '/products/cr41-filter-media',
        'Activated Alumina': '/products/activated-alumina-filter-media',
        'CRY+': '/products/cry-plus-filter-media',
        'ProBlend Custom Filtration Media': '/products/problend™-custom-filtration-media',
        'ProBlend™ Custom Filtration Media': '/products/problend™-custom-filtration-media',
        'CRAC': '/products/crac-filter-media',
        'K-CRAC': '/products/k-crac-filter-media',
        'PR-O': '/products/pr-o',
        'PR-W': '/products/pr-w',
        'B80': '/products/b80',
        'Perform 5000': '/products/perform-5000',
        'Perform 6000': '/products/perform-6000',
        'CR2': '/products/cr2-filter-media',
        'G-CRAC': '/products/g-crac-filter-media',
        'Silica Gel 60A': '/products/silica-gel-60a-filter-media',
        'Silica Gel': '/products/silica-gel-60a-filter-media',
        'Ulti Filter Kit': '/products/ulti-filter-kit',
        'Pressurized Hose': '/products/pressurized-hose',
        'PTFE FDA Gasket': '/products/ptfe-fda-gasket',
        'Bolted High Pressure Clamp': '/products/bolted-high-pressure-clamp',
        'End Cap Reducer': '/products/end-cap-reducer',
        'CRC Column Mounting Bracket': '/products/crc-column-mounting-bracket',
        'Flow Controller': '/products/fc4080-flow-controller',
        'Media Bros Filter Screen': '/products/media-bros-filter-screen',
        'Swagelok Needle Valve': '/products/swagelok-needle-valve',
        'Ulti Filter Max 5/10" 2um Housing': '/products/ulti-filter-max-5-inch-10-inch-2um-housing',
        'Ulti Filter Max 5/10" Filters (6-pack)': '/products/ulti-filter-max-5-inch-10-inch-filters-6-pack',
        'CRC Filter Spool': '/products/crc-filter-spool',
        'CRX™': '/products/crx-filter-media',
        'CRX-M™': '/products/medium-flow-crx',
        'CRY™': '/products/cry-filter-media',
        'CRY-M™': '/products/cry-medium-flow',
        'CR41™': '/products/cr41-filter-media',
        'CRY+™': '/products/cry-plus-filter-media',
        'ProBlend Custom Filtration Media™': '/products/problend™-custom-filtration-media',
        'ProBlend™ Custom Filtration Media': '/products/problend™-custom-filtration-media',
        'CRAC™': '/products/crac-filter-media',
        'K-CRAC™': '/products/k-crac-filter-media',
        'CR2™': '/products/cr2-filter-media',
        'G-CRAC™': '/products/g-crac-filter-media',
        'MB-5': '/products/mb-5'
    };
      
    const sortedKeys = Object.keys(wordLinks).sort((a, b) => b.length - a.length);
    const escapedKeys = sortedKeys.map(k => k.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
    const regex = new RegExp(`\\b(${escapedKeys.join('|')})(?=$|[^A-Za-z0-9_])`, 'gi');

    if (debugLinkWords) {
      console.log('[EL blog article links] regex:', regex);
      console.log('[EL blog article links] CRY-related keys:', sortedKeys.filter(key => key.includes('CRY')));
    }

    const lastLinkedPositions = new Map();
    let articleCharacterIndex = 0;

    const normalizePath = (url) => {
      try {
        return new URL(url, window.location.origin).pathname.replace(/\/$/, '');
      } catch (error) {
        return url.replace(/\/$/, '');
      }
    };

    const urlsByNormalizedPath = Object.values(wordLinks).reduce((urls, url) => {
      urls.set(normalizePath(url), url);
      return urls;
    }, new Map());

    const getExistingProductLinkUrl = (link) => {
      const normalizedHref = normalizePath(link.getAttribute('href') || '');
      const linkedProductUrl = urlsByNormalizedPath.get(normalizedHref);

      if (linkedProductUrl) {
        return linkedProductUrl;
      }

      const linkedText = link.textContent.trim();
      const wordKey = sortedKeys.find(word => {
        const escapedWord = word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        const wordRegex = new RegExp(`\\b${escapedWord}(?=$|[^A-Za-z0-9_])`, 'i');
        return wordRegex.test(linkedText);
      });

      return wordKey ? wordLinks[wordKey] : null;
    };

    const walk = (node) => {
        // Process only <p>, <ul>, or <ol> elements
        if (
          node.nodeType === Node.ELEMENT_NODE &&
          ['p', 'ul', 'ol'].includes(node.tagName.toLowerCase())
        ) {
          const processTextNodes = (child) => {
            if (child.nodeType === Node.TEXT_NODE) {
              const originalText = child.textContent;
              const shouldDebugTextNode = debugLinkWords && debugTerms.some(term => originalText.includes(term));

              if (shouldDebugTextNode) {
                console.log('[EL blog article links] text node before:', originalText);
                console.log('[EL blog article links] regex matches:', [...originalText.matchAll(regex)].map(result => ({
                  match: result[0],
                  index: result.index,
                  nextCharacter: originalText.charAt(result.index + result[0].length) || null
                })));
              }

              const replaced = originalText.replace(regex, (match, _matchedWord, offset) => {
                const wordKey = Object.keys(wordLinks).find(w => w.toLowerCase() === match.toLowerCase());
                const url = wordKey ? wordLinks[wordKey] : null;
                const trackingKey = url || (wordKey ? wordKey.toLowerCase() : null);
                const matchCharacterIndex = articleCharacterIndex + offset;
                const lastLinkedPosition = trackingKey ? lastLinkedPositions.get(trackingKey) : null;
                const canLink =
                  trackingKey &&
                  (
                    lastLinkedPosition === undefined ||
                    matchCharacterIndex - lastLinkedPosition >= minimumCharactersBetweenSameLinks
                  );

                if (shouldDebugTextNode) {
                  console.log('[EL blog article links] replacement candidate:', {
                    match,
                    wordKey,
                    url,
                    matchCharacterIndex,
                    lastLinkedPosition,
                    charactersSinceLastLink: lastLinkedPosition === undefined ? null : matchCharacterIndex - lastLinkedPosition,
                    canLink
                  });
                }
                if (canLink) {
                  lastLinkedPositions.set(trackingKey, matchCharacterIndex);
                  return `|||${match}|||`;
                }
                return match;
              });
      
              if (replaced !== originalText) {
                if (shouldDebugTextNode) {
                  console.log('[EL blog article links] text node after markers:', replaced);
                }

                const wrapper = document.createElement('span');
                wrapper.innerHTML = replaced.replace(/\|\|\|(.+?)\|\|\|/g, (_, word) => {
                  const wordKey = Object.keys(wordLinks).find(w => w.toLowerCase() === word.toLowerCase());
                  const url = wordKey ? wordLinks[wordKey] : '#';                    
                  if (shouldDebugTextNode) {
                    console.log('[EL blog article links] creating link:', { word, wordKey, url });
                  }
                  return `<a href="${url}" style="text-decoration: underline; font-weight: bold; color: #478189;">${word}</a>`;
                });
                child.replaceWith(wrapper);
              } else if (shouldDebugTextNode) {
                console.log('[EL blog article links] no replacements made for text node.');
              }

              articleCharacterIndex += originalText.length;
            } else if (
              child.nodeType === Node.ELEMENT_NODE &&
              !child.closest('a')
            ) {
              child.childNodes.forEach(processTextNodes);
            } else if (
              child.nodeType === Node.ELEMENT_NODE &&
              child.closest('a')
            ) {
              const linkedProductUrl = getExistingProductLinkUrl(child.closest('a'));

              if (linkedProductUrl) {
                lastLinkedPositions.set(linkedProductUrl, articleCharacterIndex);

                if (debugLinkWords) {
                  console.log('[EL blog article links] existing product link counted:', {
                    text: child.textContent,
                    href: child.closest('a').getAttribute('href'),
                    trackingKey: linkedProductUrl,
                    articleCharacterIndex
                  });
                }
              }

              articleCharacterIndex += child.textContent.length;
            }
          };
      
          node.childNodes.forEach(processTextNodes);
        } else {
          node.childNodes.forEach(walk); // Keep walking down the DOM tree
        }
      };          
  
    document.querySelectorAll('.article__block--content').forEach(el => {
      walk(el);
    });
  }
  
document.addEventListener('DOMContentLoaded', boldUnderlineAndLinkWords);

function styleArticleLinks() {
const links = document.querySelectorAll('.article__content a');
links.forEach(link => {
    if (!link.classList.contains('c-btn')) {
    link.style.color = '#478189';
    link.style.fontWeight = '600';
    }
});
}  
  
// Run the function after the DOM is loaded
document.addEventListener('DOMContentLoaded', styleArticleLinks);

function includeSpans() {
    const aTagSpans = document.querySelectorAll(".article__content a span");
    aTagSpans.forEach(element => {
        element.style.setProperty("font-weight", "600");
    });
}  

document.addEventListener("DOMContentLoaded", includeSpans);
